export enum RoleType {
  SuperAdmin = 1,
  Admin = 2,
  User = 3,
  Technician = 4,
  VumatelUser = 5,
  Sales = 6,
  Staff = 7,
  Accounts = 8,
  Technical = 9,
  Reseller = 7,
  ResellerCustomer = 14,
  RetentionAgent = 17

}
